import {Injectable, OnInit} from '@angular/core';
import {Router} from "@angular/router";
import {Observable} from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/interval';
import {Http, Headers,Response, RequestOptions, URLSearchParams} from '@angular/http';

@Injectable()
export class DataService implements OnInit{
  /**
   * Review
   * Todo:
   * Неиспользуемые переменные
   */

  isLoggedIn: boolean = false;
  personalCabinetData : any = {};
  isVerificate: boolean = false;

  public data: any = {};
  public Password: any;
  public indentureData: any;
  public receipt: any;

  constructor(private http: Http, public router: Router) {

  }

  public getData(): Observable<any> {
    if (this.indentureData) {
      return Observable.create(observer => observer.next(this.indentureData));

    } else {
      let token = localStorage.getItem("token");
      return this.getDataByToken(token);
    }
  };

  public getDataByToken(token: string): Observable<any> {
    return this.http.post('/api/order', {token: token ? token : "" });
  };

  getPersonalCabinetData() {
    if ('clientId' in this.personalCabinetData) {
      return Observable.create(observer =>  observer.next(this.personalCabinetData));
    } else {
      let clientId =  localStorage.getItem("clientId");
      let cabinet =  this.getCabinetDataByClientId(clientId);
       this.login();
      return Observable.create(observer =>  observer.next(cabinet));
    }
  };

  public getCabinetDataByClientId(clientId: string) {
    return this.http.post('/api/lcByClientId', {'clientId': clientId})
      /*.map(
        (response: Response) => {
          let cabinet = response.json();
          console.log(response.json());
          return cabinet;
        }
      );*/
  };



  public getDataByIddCsd(IDcontract: number, CScontract: number): Observable<any> {
    return this.http.post('/api/login', {idd: IDcontract, csd: CScontract});
  };

  public getQRByIddCsd(IDcontract: number, CScontract: number): Observable<any> {
    return this.http.post('/api/qr', {idd: IDcontract, csd: CScontract});
  };


  public setData(data: any) {
    localStorage.setItem('token', JSON.parse(data._body).EventID);
    localStorage.setItem('accessToken', JSON.parse(data._body).token);
    this.indentureData = data;
  }


  public setReceipt(receipt: any) {
    localStorage.setItem('receipt', JSON.stringify(receipt));
    try {
      let receiptData = JSON.parse(receipt._body);
      if (receiptData.statusToken) {
        localStorage.setItem('paymentStatusToken', receiptData.statusToken);
      }
    } catch (error) {
      localStorage.removeItem('paymentStatusToken');
    }
    this.receipt = receipt;
  }

  public getPaymentStatus(statusToken: string): Observable<any> {
    return this.http.get('/api/payment/status/' + encodeURIComponent(statusToken))
      .map((response: Response) => response.json());
  }

  /**
   * Review
   * Todo:
   * В названии функции должно быть действие
   */
  public recordProlongationConfirmation(event: string, index: number, selectedAt: string, confirmedAt: string): Observable<any> {
    return this.http.post('/api/payment/confirmation', {
      event: event, index: index, selectedAt: selectedAt, confirmedAt: confirmedAt,
      token: localStorage.getItem('accessToken')
    });
  }

  public periodProlong(EventID: any, idPeriod: number, totalSum: number, email: string, token: string): Observable<any> {
    return this.http.post('/api/payment', {event: EventID, index: idPeriod, totalSum: totalSum, email: String(email || '').trim(), token: token});
  };

  /**
   * Review
   * Todo:
   * Неиспользуемые функции
   */
 getDefaultData() {
  this.http.get('/api/config').subscribe(
    data => {
      this.data = JSON.parse(data["_body"]);
    }
  );
  }

  public payment(info:any): Observable<any> {
    let headers = new Headers();
    headers.set('Content-Type', 'application/x-www-form-urlencoded');
/* headers.set('Access-Control-Allow-Origin', '*');*/
    let body = new URLSearchParams();
    Object.keys(info).forEach(key => {
      body.set(key, info[key]);
    });
    return this.http.post('https://www.portmone.com.ua/gateway/', body.toString(), {headers: headers});
  };
  /**
   * Review
   * Todo:
   * В названии функции должно быть действие
   */
  public sendActivity(IDcontract: number, activity: boolean): Observable<any> {
    return this.http.post('/api/activityTracker', {idd: IDcontract, activity: activity});
  };

  public sendCabinetActivity(clientId: number, activity: boolean): Observable<any> {
    return this.http.post('/api/activityTrackerCabinet', {clientId: clientId, activity: activity});
  };

  postLcRegistration(form: any){
    return this.http.post('/api/lcRegistration', form);
  };



  postLcLogin(form: any){
    return this.http.post('/api/lcLogin', form);
  };



  public setPersonalCabinetData(data: any) {
    localStorage.setItem('clientId', data.clientId);
    this.personalCabinetData = data;
  }

  isAuthenticated() {

    return this.isLoggedIn;
  }
  login() {
    this.isLoggedIn = true;
    console.log('logined');
  }
  logout() {
    this.isLoggedIn = false;
  }

  ngOnInit(){}

  public async transitionToPortmone(data: any): Promise<any> {
    await this.http.post('/api/activityTracker/portmone/transition', {data: data})
      .toPromise();
  };

}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/services/data.service.ts